<template>
  <hic-dialog :title="title" :visible="visible" @close="cancel" width="55rem" top="4vh" :close-on-click-modal="false" append-to-body >
    <el-form :inline="true" :model="value" :rules="comRules" ref="editor" label-width="8rem" label-position="right">
      <basics v-model="value" />
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item name="1" title="类型相关：">
          <list-optional v-if="list.includes(value.type)" v-model="value" />
          <scope-optional v-else-if="scope.includes(value.type)" v-model="value" />
          <table-optional v-else-if="table.includes(value.type)" v-model="value" />
          <text-optional v-else-if="text.includes(value.type)" v-model="value" />
          <figure-optional v-else-if="figure.includes(value.type)" v-model="value" />
          <select-optional v-else-if="select.includes(value.type)" v-model="value" />
          <date-optional v-else-if="date.includes(value.type)" v-model="value" />
        </el-collapse-item>
        <el-collapse-item name="2" title="数据绑定：" v-if="value.type != '数据组' && value.type != '区域'">
          <interface v-model="value" />
        </el-collapse-item>
        <!-- <el-collapse-item name="4">
          <template slot="title">
            <span class="title">规则信息</span>
          </template>
          <rule v-model="value" />
        </el-collapse-item> -->
      </el-collapse>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="save" :disabled="disabledSave" :loading="disabledSave">确 定</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import Basics from "./editModule/basics.vue";
  import Interface from "./editModule/interface.vue";
  import editorUtils, { eProps } from "@/common/editorUtils";
  // import Rule from "./editModule/rule.vue";

  export default {
    props: {
      visible: Boolean,
      value: Object,
      dictList: Array,
    },
    components: {
      Basics,
      ListOptional: () => import("./editModule/listOptional.vue"),
      ScopeOptional: () => import("./editModule/scopeOptional.vue"),
      TableOptional: () => import("./editModule/tableOptional.vue"),
      TextOptional: () => import("./editModule/textOptional.vue"),
      FigureOptional: () => import("./editModule/figureOptional.vue"),
      SelectOptional: () => import("./editModule/selectOptional.vue"),
      DateOptional: () => import("./editModule/dateOptional.vue"),
      Interface,
      // Rule,
    },
    data() {
      return {
        deptFilterKey: null,
        comRules: {
          type: [
            {
              required: true,
              message: "请选择类型",
              trigger: "blur",
            },
          ],
          name: [
            {
              required: true,
              message: "请输入名称",
              trigger: "blur",
            },
            {
              max: 20,
              message: "名称长度在 20 个字符以内",
              trigger: "blur",
            },
          ],
        },
        disabledSave: false,
        activeName: "1",
        list: ["单选框", "多选框", "单选文本框", "多选文本框"],
        scope: ["数据组", "区域"],
        table: ["表格"],
        text: ["文本框"],
        figure: ["数字框"],
        select: ["选择框"],
        date: ["日期框"],
      };
    },
    computed: {
      title() {
        if (!this.value.id) {
          return "元素新建"
        }
        return "元素编辑";
      },
    },
    methods: {

      cancel() {
        this.$refs.editor.resetFields();
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      save: function () {
        let _this = this;

        this.$refs.editor
          .validate()
          .then((_) => {
            _this.resetKey();
            _this.disabledSave = true;
            return this.$api.Element.save(_this.value);
          })
          .then((newEntity) => {
            _this.$refs.editor.resetFields();
            _this.$message.success("保存成功！");
            _this.$store.dispatch("loaders", "MrElement");
            _this.$emit("saved", newEntity);
            _this.$emit("update:visible", false);
          })
          .catch((err) => {
            if (err) {
              _this.$message.error(err.message || err);
            }
          })
          .finally(() => {
            _this.disabledSave = false;
          });
      },
      resetKey() {
        let _this = this;
        eProps.forEach((prop) => {
          if (prop.eleType.indexOf(editorUtils.getTypeCode(_this.value.type)) < 0) {
            this.value[prop.code] = null;
          }
        });
      },
    },
  };
</script>
